import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { getLayoutMode } from '@app/store/layouts/layout-selector';
import { LAYOUT_MODE } from '@app/store/layouts/layout';

@Component({
  selector: 'app-auth-header',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './auth-header.component.html',
  styleUrl: './auth-header.component.scss'
})
export class AuthHeaderComponent implements OnInit {
  mode: string;
  store = inject(Store);

  ngOnInit(): void {
    this.store.select(getLayoutMode).subscribe((mode) => {
      this.mode = mode;
    })
  }

  protected readonly LAYOUT_MODE = LAYOUT_MODE;
}
